import { hideSectionsOnBacklink } from '@/modules/misc/common/hideSectionsOnBacklink.js';
import { initPreviousEvents } from '@/modules/public/shared/previous-events';
import { initScrollingNav } from '@/modules/public/shared/scrolling-nav';
import { captureUtmParams } from '@/services/utm-tracker';
import { trackRoomClicked } from '@/services/venuepage-interactions-tracker';

import { init as initLocationAutocomplete } from '../location-page/location-page.autocomplete.js';
import { init as initSearchForm } from '../location-page/location-page.search-form';
import {
  initNearbyExperiment,
  // init3DTourExperiment,
  initVenueMenusExperiment,
} from './experiments';
import initMobileSlider from './mobileSlider.js';
import initReviewsModal from './reviewsModal.js';
import { init as initHeader } from './venuepage.header.js';
import { init as initMap } from './venuepage.map.js';
import { init as initMosaicGallery } from './venuepage.mosaic-gallery.js';

initMobileSlider('venuePage');

// The shared wishlist module only toggles the --selected class, so mirror it for assistive tech.
$.subscribe('wishList:change', () => {
  document.querySelectorAll('.c-room-card-horizontal .js-wishlist-toggle').forEach((heart) => {
    heart.setAttribute('aria-pressed', heart.classList.contains('c-room-card__heart--selected'));
  });
});

function trackEventOffersInteractions() {
  const $seeFullOfferButton = $('.js-venuepage-event-offer-cta');

  $seeFullOfferButton.onIntersection({
    callback: () => {
      App.track.event('venue_page_interaction', {
        section: 'event_offers',
        element: 'see_full_offer_button',
        interaction: 'visible',
      });
    },
    once: true,
  });

  $seeFullOfferButton.on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'event_offers',
      element: 'see_full_offer_button',
      interaction: 'click',
    });
  });
}

$(document).ready(() => {
  App.log('venuePage.mainStart');

  initScrollingNav({
    sections: [
      { label: 'Overview', selector: '.p-venuepage-header' },
      { label: 'Spaces', selector: '.p-venuepage-rooms-v2' },
      { label: 'Reviews', selector: '.p-venuepage-reviews' },
      { label: 'Prices', selector: '#p-venuepage-pricing' },
      { label: 'Facilities', selector: '#p-venuepage-features' },
      { label: 'FAQ', selector: '.p-venuepage-faq' },
    ],
    trackingEventName: 'venue_page_interaction',
  });

  const venueNameElement = document.querySelector('.p-venuepage-header__name').childNodes[0];
  const venueName = venueNameElement.textContent.trim();
  const pricingsLiquidityIndicators = window.__TGV_ROOM_PRICINGS_LIQUIDITY_INDICATORS ?? {};
  const $peopleInput = $('.p-venuepage-search__content-v2 #hero-people');

  // select / copy location (next to "show map" button)
  App.components.selection_tracking(
    document.querySelector('.js-open-map-modal .c-room-header__text_link').childNodes[0],
    (event, selection) => {
      App.track.event('venue_page_interaction', {
        section: 'summary',
        element: 'address',
        element_value: selection,
        interaction: event.type === 'copy' ? 'copy' : 'select',
      });
    },
    500,
  );

  // select / copy location (next to map)
  App.components.selection_tracking(
    document.querySelector('.p-venuepage-location__item span')?.childNodes[0],
    (event, selection) => {
      App.track.event('venue_page_interaction', {
        section: 'location',
        element: 'address',
        element_value: selection,
        interaction: event.type === 'copy' ? 'copy' : 'select',
      });
    },
  );

  // select / copy venue name
  App.components.selection_tracking(
    venueNameElement,
    (event, selection) => {
      App.track.event('venue_page_interaction', {
        section: 'summary',
        element: 'venue_name',
        element_value: selection,
        interaction: event.type === 'copy' ? 'copy' : 'select',
      });
    },
  );

  $('.js-show-more-rooms').on('click', (event) => {
    $(event.target).remove();

    App.track.event('venue_page_interaction', {
      section: 'spaces',
      element: 'show_all_spaces_button',
      element_value: event.target.dataset.hiddenRoomCount,
      interaction: 'click',
    });
  });

  $('.js-venuepage-reviews').on('click', (event) => {
    App.track.event('venue_page_interaction', {
      section: 'reviews',
      element: 'read_all_button',
      element_value: event.target.dataset.reviewsCount,
      interaction: 'click',
    });
  });

  $('.js-venuepage-reviews-button').on('click', (event) => {
    App.track.event('venue_page_interaction', {
      section: 'reviews',
      element: 'show_all_button',
      element_value: event.target.dataset.reviewsCount,
      interaction: 'click',
    });
  });

  $('.js-open-reviews-modal').on('click', (event) => {
    App.track.event('venue_page_interaction', {
      section: 'summary',
      element: 'read_all_reviews_button',
      element_value: event.target.dataset.reviewsCount,
      interaction: 'click',
    });
  });

  $('.js-open-map-modal').on('click', () => {
    window.triggerMapModal();
  });

  $('.js-open-report-modal').on('click', () => {
    window.triggerReportModal();
  });

  $('.js-venuepage-tag').on('click', (event) => {
    const tag = $(event.target).text().trim();
    App.track.event('venue_page_interaction', {
      section: 'seo_links',
      element: 'link',
      element_value: tag,
      interaction: 'click',
    });

    // Track as popular_event_types section
    App.track.event('venue_page_interaction', {
      section: 'popular_event_types',
      element: '',
      element_value: tag,
      interaction: 'click',
    });
  });

  $('.c-pricing-table__day').on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'prices',
      element: 'price',
      interaction: 'click',
      exp_pricing_update: pricingsLiquidityIndicators?.inExperiment && pricingsLiquidityIndicators?.lastUpdateInDays ? 'Yes' : 'No',
      exp_pricing_update_value: pricingsLiquidityIndicators?.lastUpdateInDays ?? null,
      exp_pricing_confirmation: pricingsLiquidityIndicators?.inExperiment && pricingsLiquidityIndicators?.lastUpdateConfirmations ? 'Yes' : 'No',
      exp_pricing_confirmation_value: pricingsLiquidityIndicators?.lastUpdateConfirmations ?? null,
    });
  });

  App.components.room_pricing_table(
    $.fn.findAnyInDocument('.c-pricing-table'),
    'pricing',
  );

  initMap();
  initHeader();

  App.es6.shared.preload(['room', 'search']);

  App.track.pageViewEvent(); // venue page -> can be done via twig (block page_view_event)
  App.track.event('venue_page_pageview');

  // GA4 Venue page tracking
  $('[data-track="click"]').on('click', (e) => {
    const $target = $(e.currentTarget);
    const section = $target.data('track-section');
    const element = $target.data('track-element');
    const value = $target.data('track-value');

    if (!$target[0].classList.contains('js-skip-tracking')) {
      App.track.event('venue_page_interaction', {
        ...window.__TGV_GA4_TRACKING,
        section,
        element,
        interaction: 'click',
        element_value: value ?? null,
      });
    }
  });

  $('.js-venuepage-breadcrumb').on('click', (event) => {
    const type = event.currentTarget.dataset.type;
    const value = event.currentTarget.innerText.trim();

    App.track.event('venue_page_interaction', {
      section: 'breadcrumbs',
      element: type,
      element_value: value,
      interaction: 'click',
    });

    App.track.event('clicked_to_location_page', {
      section: 'venue_page_breadcrumbs',
      element: type,
      element_value: value,
      interaction: 'click',
    });
  });

  $('.js-venuepage-top-bar-copy-link').on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    App.track.event('venue_page_interaction', {
      section: 'share_button_drop_down',
      element: 'copy_link_button',
      element_value: venueName,
      interaction: 'click',
    });

    const el = document.createElement('textarea');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  });

  $('.js-venuepage-top-bar-email').on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    App.track.event('venue_page_interaction', {
      section: 'share_button_drop_down',
      element: 'email_button',
      element_value: venueName,
      interaction: 'click',
    });

    window.location.href = `mailto:?subject=Check this out on Tagvenue&body=Check this out on Tagvenue %0D%0A${window.location.href}`;
  });

  $('.js-pricing-update').onIntersection(() => {
    App.track.event('venue_page_interaction', {
      ...window.__TGV_GA4_TRACKING,
      section: 'prices',
      element: 'update',
      interaction: 'visible',
    });
  });

  $('.js-pricing-confirmation').onIntersection(() => {
    App.track.event('venue_page_interaction', {
      ...window.__TGV_GA4_TRACKING,
      section: 'prices',
      element: 'confirmation',
      interaction: 'visible',
    });
  });

  // Track facilities and catering section visibility
  $('#p-venuepage-features').onIntersection({
    callback: () => {
      App.track.event('venue_page_interaction', {
        section: 'facilities_and_catering_options',
        element: '',
        element_value: '',
        interaction: 'visible',
      });
    },
    once: true,
    threshold: 0.2,
  });

  // Track about venue description visibility
  $('.js-venuepage-about-section').onIntersection({
    callback: () => {
      App.track.event('venue_page_interaction', {
        section: 'about_venue',
        element: 'description',
        element_value: '',
        interaction: 'visible',
      });
    },
    once: true,
    threshold: 0.2,
  });

  $('.js-venuepage-recommended-rooms').onIntersection(() => {
    App.track.event('venue_page_interaction', {
      ...window.__TGV_GA4_TRACKING,
      section: 'recommended_venues',
      element: 'room_tile_carousel',
      interaction: 'visible',
    });
  });

  $('.js-venuepage-ai-overview').onIntersection(() => {
    App.track.event('venue_page_interaction', {
      section: 'ai_venue_summary',
      element: 'summary',
      element_value: '',
      interaction: 'visible',
    });
  });

  $('.js-reviews-card-see-all-btn').on('click', () => {
    App.track.event('venue_page_interaction', {
      ...window.__TGV_GA4_TRACKING,
      section: 'review_summary',
      element: 'see_all_button',
      interaction: 'click',
    });
  });

  $('.js-veneupage-see-other-venues').on('click', () => {
    App.track.event('venue_page_interaction', {
      ...window.__TGV_GA4_TRACKING,
      section: 'recommended_venues',
      element: 'see_more_button',
      interaction: 'click',
    });
  });

  // Track recommended venues carousel browse
  $('.js-venuepage-recommended-rooms').on('click', '.c-box-carousel-arrow', () => {
    App.track.event('venue_page_interaction', {
      section: 'recommended_venues',
      element: '',
      element_value: '',
      interaction: 'browse',
    });
  });

  $(document).on('click', '.c-hire-reviews .js-truncate-description', () => {
    App.track.event('venue_page_interaction', {
      section: 'review',
      element: 'show_more_button',
      interaction: 'click',
    });
  });

  $('.p-venuepage-search__content-v2 #hero-event-type').on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'search_bar',
      element: 'event_type',
      interaction: 'click',
    });
  });
  $peopleInput.on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'search_bar',
      element: 'guests',
      interaction: 'click',
    });
  });
  $peopleInput.on('keydown', (e) => {
    if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
      e.preventDefault();
    }
  });
  $('.p-venuepage-search__content-v2 #hero-location').on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'search_bar',
      element: 'location',
      interaction: 'click',
    });
  });

  const $messageHostButtons = $('.js-message-host-button');
  $messageHostButtons.on('click', () => {
    App.track.event('venue_page_interaction', {
      section: 'venue_manager_section',
      element: 'message_host_button',
      interaction: 'click',
    });
  });

  $messageHostButtons.onIntersection(() => {
    App.track.event('venue_page_interaction', {
      section: 'venue_manager_section',
      element: 'message_host_button',
      interaction: 'visible',
    });
  });

  function trackFaqSectionEvents() {
    const accordionTriggers = document.querySelectorAll('.ds-accordion__trigger');

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.parentElement.classList.contains('ds-accordion--open');
        const questionNumber = Array.from(trigger.parentElement.parentElement.children)
          .filter((el) => el.classList.contains('ds-accordion'))
          .indexOf(trigger.parentElement) + 1;

        App.track.event('venue_page_interaction', {
          section: 'faq',
          element: 'question',
          element_value: questionNumber,
          interaction: isExpanded ? 'unfold' : 'fold',
        });
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          App.track.event('venue_page_interaction', {
            section: 'faq',
            element: 'question',
            element_value: null,
            interaction: 'visible',
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });

    const faqSection = document.querySelector('.p-venuepage-faq');

    if (faqSection) {
      observer.observe(faqSection);
    }
  }

  setTimeout(() => {
    $('.p-venuepage-rooms__content, .p-venuepage-rooms-v2__content').on('click', '.c-room-card, .c-room-card-horizontal', (e) => {
      const $target = $(e.currentTarget);
      const roomId = $target.data('id');
      const venueId = $target.data('venue-id');
      const index = $target.data('index');

      const { target } = e;

      if (target?.closest?.('.arrow')) { // carousel arrow clicked
        return;
      }

      if (target?.closest?.('.c-room-card__heart')) {
        return;
      }

      trackRoomClicked(+roomId);

      let triggerElement = null;
      let roomTileElement = null;

      if (target.tagName === 'IMG') {
        triggerElement = 'room_tile_photo';
        roomTileElement = 'photo_preview';
      } else if (target.tagName === 'A') {
        triggerElement = 'room_tile_button';
        roomTileElement = 'enquire_now_button';
      } else if (target?.closest?.('.js-room-card-name')) {
        triggerElement = 'room_tile_name';
        roomTileElement = 'room_name';
      } else if (target?.closest?.('.js-room-card-price-button')) {
        triggerElement = 'room_tile_pricing_trigger';
        roomTileElement = null;
      }

      if (!triggerElement) {
        return;
      }

      App.track.event('clicked_to_room_page', {
        section: 'venue_page_spaces',
        element: triggerElement,
        element_value: roomId,

        position: (+index + 1),
        room_id: roomId,
        venue_id: venueId,

        interaction: 'click',
      });

      // Track venue_page_interaction event for room tiles
      if (roomTileElement) {
        App.track.event('venue_page_interaction', {
          section: 'room_tile',
          element: roomTileElement,
          element_value: String(+index + 1),
          interaction: 'click',
        });
      }
    });

    // Track photo carousel browse on room tiles
    $('.p-venuepage-rooms__content, .p-venuepage-rooms-v2__content').on('click', '.lory-prev, .lory-next', (e) => {
      const $roomCard = $(e.target).closest('.c-room-card-horizontal, .c-room-card');
      const index = $roomCard.data('index');

      App.track.event('venue_page_interaction', {
        section: 'room_tile',
        element: 'photo_preview',
        element_value: String(+index + 1),
        interaction: 'browse',
      });
    });
  });

  initLocationAutocomplete();
  initMosaicGallery();
  // Initialize search form
  // Note: Google places autocomplete is initialised separately in maps_callback file
  initSearchForm({ disableLocationPageEvents: true });

  // init3DTourExperiment();
  initVenueMenusExperiment();
  initNearbyExperiment();

  trackFaqSectionEvents();
  initReviewsModal('venuePage');

  App.components.room_cards_carousel();
  App.views.shared.detect_device();
  hideSectionsOnBacklink();

  App.es6.shared.lory_carousel();
  App.es6.shared.in_view();

  App.views.room.truncate();

  trackEventOffersInteractions();
  initPreviousEvents({ eventName: 'venue_page_interaction' });

  captureUtmParams();

  App.log('venuePage.mainDone');
});
